import { render, staticRenderFns } from "./DataTableMain.vue?vue&type=template&id=0a4d9e0c"
import script from "./DataTableMain.vue?vue&type=script&lang=js"
export * from "./DataTableMain.vue?vue&type=script&lang=js"
import style0 from "./DataTableMain.vue?vue&type=style&index=0&id=0a4d9e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports